import TagManager from 'react-gtm-module';

export const usePhotoVenueTag = ({ index, totalPhotos, venueName, venueId }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_photo_venue',
      category: 'UI Interaction',
      action: 'Click',
      label: `Photo ${index + 1} of ${totalPhotos}`,
      venueName,
      venueId
    }
  });

export const useVenueTag = ({ label, venueId }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_venue',
      category: 'UI Interaction',
      action: 'Click',
      label,
      venueId
    }
  });

export const useFavoriteVenueTag = ({ label, venueName }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_favorite_venue',
      category: 'UI Interaction',
      action: 'Click',
      label,
      venueName
    }
  });
